import * as angular from 'angular';
import foldToASCII from 'data/foldToASCII';
import { BuilderFeatures } from '../../builder/BuilderFeatures';
const EditAction = 'EditApplicationItem';
export class ApplicationItemController {
    static $inject = ['$scope', '$timeout', '$rootScope', 'ApplicationService2', 'TenantService', 'ContextProcessorService', 'SegmentService', 'CurrentApplicationService', 'BlipToastService', '$translate', 'ngToast'];
    constructor($scope, $timeout, $rootScope, ApplicationService2, TenantService, ContextProcessorService, SegmentService, CurrentApplicationService, BlipToastService, $translate, ngToast) {
        'ngInject';
        this.$timeout = $timeout;
        this.ApplicationService2 = ApplicationService2;
        this.TenantService = TenantService;
        this.ContextProcessorService = ContextProcessorService;
        this.SegmentService = SegmentService;
        this.CurrentApplicationService = CurrentApplicationService;
        this.BlipToastService = BlipToastService;
        this.$translate = $translate;
        this.ngToast = ngToast;
        this.shouldAvoidDuplicateRouterService = false;
        this.isApplicationOnline = false;
        this.updateBindingElements = () => {
            this.$rootScope.$$phase || this.$rootScope.$apply();
        };
        this.$onInit = async () => {
            try {
                this.currentApplication = await this.CurrentApplicationService.fetchApplication();
                if (!this.application) {
                    return;
                }
                this.isApplicationOnline = await this.ApplicationService2.isOnline(this.application);
                this.application.tenantId = undefined;
                this.application.tenantUrl = undefined;
                this.application.tenantNotFound = undefined;
                this.application.warning = undefined;
                const isOrganizationEnabled = await this.TenantService.isOrganizationEnabled();
                if (isOrganizationEnabled) {
                    const { tenantId } = await this.ApplicationService2.getApplication(this.application.shortName);
                    this.application.tenantId = tenantId;
                    this.application.tenantUrl = this.TenantService.getTenantUrl(tenantId, true);
                    this.activeTenant = this.ContextProcessorService.tenant.id;
                    if (tenantId !== this.activeTenant) {
                        this.application.warning = true;
                    }
                }
            }
            catch (err) {
                this.application.tenantNotFound = true;
            }
        };
        this.$onChanges = async () => {
            if (this.application && this.chatbots) {
                this.hasChatbotPermission = this.chatbots.some((c) => c.shortName === this.application.shortName);
            }
            this.isApplicationOnline = this.application !== undefined ? await this.ApplicationService2.isOnline(this.application) : undefined;
        };
        this.newItem = () => {
            this.FORM_STATE = 'added';
            this.isSearching = true;
            this.searchBots(undefined);
        };
        this.onChangeServiceName = (event) => {
            this.editingApplication.service = event.detail?.value;
        };
        this.onFocusLongName = () => {
            this.searchBots(this.editingApplication.longName);
        };
        this.onChangeLongName = (event) => {
            const text = event.detail?.value;
            this.searchBots(text);
        };
        this.onChangeIsDefault = (event) => {
            this.editingApplication.isDefault = event.detail?.checked;
            if (this.editingApplication.isDefault) {
                this.editingApplication.isPersistent = false;
                this.editingApplication.redirectTimeoutInSeconds = undefined;
            }
            this.updateBindingElements();
        };
        this.onChangeIsPersistent = (event) => {
            this.editingApplication.isPersistent = event.detail?.checked;
            if (this.editingApplication.isPersistent) {
                this.editingApplication.redirectTimeoutInSeconds = undefined;
            }
            this.updateBindingElements();
        };
        this.onChangeRedirectTimeoutInSeconds = (event) => {
            this.editingApplication.redirectTimeoutInSeconds = event.detail?.value;
        };
        this.FORM_STATE = 'initial';
        this.editingApplication = new ChildApplication();
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$rootScope.$on(EditAction, () => {
            this.searchResults = [];
        });
        this.checkFeatures();
    }
    async checkFeatures() {
        const [shouldAvoidDuplicateRouterService] = await Promise.all([
            BuilderFeatures.shouldAvoidDuplicateRouterServiceEnable(),
        ]);
        this.shouldAvoidDuplicateRouterService = shouldAvoidDuplicateRouterService;
    }
    async saveItem() {
        if (!this.isRedirectTimeoutInSecondsValid()) {
            const erro181 = await this.$translate('utils.errorMsg.181');
            this.ngToast.danger(erro181);
            return;
        }
        try {
            await this.save();
            this.SegmentService.createTrack(`router-services-${this.FORM_STATE}`, {
                botName: this.currentApplication.name,
                botIdentifier: this.currentApplication.shortName,
                serviceName: this.editingApplication.service,
                isPrincipal: this.editingApplication.isDefault,
                botServiceIdentifier: this.editingApplication.shortName,
            });
            this.resetForm();
        }
        catch (e) {
            console.error(e);
        }
    }
    isRedirectTimeoutInSecondsValid() {
        const redirectTimeout = this.editingApplication.redirectTimeoutInSeconds;
        if (!redirectTimeout) {
            return true;
        }
        const maxIntegerValue = 2 ** 31;
        let parsedValue;
        if (typeof redirectTimeout !== 'number') {
            if (!/^[0-9]*$/.test(redirectTimeout)) {
                return false;
            }
            parsedValue = parseInt(redirectTimeout);
        }
        else {
            parsedValue = redirectTimeout;
        }
        return parsedValue > 0 && parsedValue < maxIntegerValue;
    }
    async save() {
        const saveEvent = await this.onSave({
            $application: this.editingApplication,
            $isEditing: this.singleForm ? false : true,
        });
        if (!saveEvent) {
            return;
        }
    }
    exclude() {
        const payload = angular.copy({
            botName: this.currentApplication.name,
            botIdentifier: this.currentApplication.shortName,
            serviceName: this.application.service,
            isPrincipal: this.application.isDefault,
            botServiceIdentifier: this.application.shortName,
        });
        this.$timeout(() => { this.onExclude({ $application: this.application }); });
        this.SegmentService.createTrack('router-services-deleted', payload);
    }
    editItem() {
        this.editingApplication = angular.copy(this.application);
        if (this.editingApplication.isDefault == undefined) {
            this.editingApplication.isDefault = false;
        }
        this.$rootScope.$broadcast(EditAction);
        this.FORM_STATE = 'edited';
    }
    cancelEdit() {
        this.editingApplication = new ChildApplication();
        this.FORM_STATE = 'initial';
        this.searchBots(undefined);
    }
    hasRequiresFieldsFilled() {
        return this.editingApplication.service != undefined && this.editingApplication.longName != undefined;
    }
    resetForm() {
        this.editingApplication = new ChildApplication();
        this.FORM_STATE = 'initial';
    }
    async selectApplication(bot, application) {
        if (!bot.isOnline) {
            this.BlipToastService.show('danger', {
                msg: await this.$translate('applications.application.noPublishedBot'),
            });
            return;
        }
        application.identity = bot.shortName + '@msging.net';
        application.longName = bot.name;
        application.shortName = bot.shortName;
        this.searchResults = [];
        this.isSearching = false;
        this.updateBindingElements();
    }
    searchBots(text) {
        this.isSearching = true;
        let filteredChatbots = undefined;
        if (this.shouldAvoidDuplicateRouterService) {
            const settings = this.currentApplication?.applicationJson.settings;
            const children = settings.children || [];
            const suggestedChatbots = this.chatbots.filter(chatbot => !children.some(child => child.shortName.toLowerCase() === chatbot.shortName.toLowerCase()));
            filteredChatbots = suggestedChatbots;
        }
        else {
            filteredChatbots = this.chatbots;
        }
        if (text && text.length > 0) {
            const searchText = foldToASCII(text).toLowerCase();
            const searchResults = filteredChatbots.filter((x) => foldToASCII(x.name)
                .toLowerCase()
                .includes(searchText));
            this.searchResults = searchResults.length > 0 ? searchResults : [];
            this.editingApplication.longName = text;
        }
        else {
            this.searchResults = filteredChatbots;
        }
        this.updateBindingElements();
    }
}
// Explicit AngularJS DI annotation for minification safety
ApplicationItemController.$inject = ['$scope', '$timeout', '$rootScope', 'ApplicationService2', 'TenantService', 'ContextProcessorService', 'SegmentService', 'CurrentApplicationService', 'BlipToastService', '$translate', 'ngToast'];
export class ChildApplication {
    constructor() {
        this.isDefault = false;
    }
}
